import { BetBuilderOptionGroupInfo } from '@cds/betting-offer/domain-specific/bet-builder';
import { EventOption, EventOptionGroup, isV2CompoundId } from '@frontend/sports/betting-offer/feature/model';

import { V1PickId, V2OptionMarketPickId } from './picks/pick-id';

export function getPickIds(precreatedGroup: BetBuilderOptionGroupInfo, eventOptionGroups: EventOptionGroup[]): (V1PickId | V2OptionMarketPickId)[] {
    const pickIds: (V1PickId | V2OptionMarketPickId)[] = [];
    precreatedGroup.options.forEach((option) => {
        eventOptionGroups.forEach((group) => {
            const optionFromBettingOffer = group.options.find((o) => o.id === option.id);
            if (optionFromBettingOffer) {
                pickIds.push(createPickId(optionFromBettingOffer, option.fixtureId));
            }
        });
    });

    return pickIds;
}

function createPickId(option: EventOption, fixtureId: string): V1PickId | V2OptionMarketPickId {
    return isV2CompoundId(fixtureId)
        ? new V2OptionMarketPickId(fixtureId, option.optionGroupId, option.id, option.priceId!)
        : new V1PickId(fixtureId, option.optionGroupId, option.id);
}
